/** Social auth providers offered on the unified login and onboarding flows. */
export type SocialLoginProvider = 'google' | 'microsoft';

/**
 * Schools integration providers whose sign-in button a cluster may list in its
 * `integrationsConfig.loginButtons`. The fake profile renders as the real one so the
 * same button can be pressed against the scriptable fake in tests and demos.
 */
export const IntegrationLoginProvider = {
  Clever: 'clever',
  FakeClever: 'fake_clever',
} as const;

// eslint-disable-next-line ts/no-redeclare
export type IntegrationLoginProvider = (typeof IntegrationLoginProvider)[keyof typeof IntegrationLoginProvider];

/** Whether the login card sits under the public nav or inside a page shell of its own. */
export const AuthFlowLayout = {
  Public: 'public',
  Embedded: 'embedded',
} as const;

// eslint-disable-next-line ts/no-redeclare
export type AuthFlowLayout = (typeof AuthFlowLayout)[keyof typeof AuthFlowLayout];

/** The steps the unified auth flow can rest on, shared by the KUI renderer and the Phoenix flow. */
export type UnifiedAuthStep = 'email' | 'method' | 'password' | 'otp' | 'choose-account' | 'school' | 'consent' | 'name' | 'details' | 'password-setup' | 'welcome' | 'mfa-enrol' | 'mfa-challenge' | 'register-disabled';

/** The authenticator secret a pending MFA enrolment shows, as a setup key and as a QR code SVG. */
export interface MfaEnrolment {
  secret: string;
  qrCodeSvg: string;
}

/**
 * What the password step offers for a forgotten password: a code to sign in with instead, or,
 * where the code already came first, a reset of the password itself.
 */
export const PasswordForgotAction = {
  Code: 'code',
  Reset: 'reset',
} as const;

// eslint-disable-next-line ts/no-redeclare
export type PasswordForgotAction = (typeof PasswordForgotAction)[keyof typeof PasswordForgotAction];
